import { StaffPanel } from './StaffPanel'

/**
 * Backward-compatible route alias.
 * The old Staff Profiles page duplicated the Team/Staff directory and is now
 * intentionally consolidated into the single Staff Portal experience.
 */
export function StaffProfilesPanel() {
  return <StaffPanel />
}
